import { gql } from '@apollo/client';
import WDT_CLASSROOM_SETTINGS_FRAGMENT from '../../fragments/wdt-classroom-settings';

const GET_GSS_CLASSROOM_SETTINGS = gql`
  query wdtClassroomSettings($where: PliClassroomSettingsWhereInput!) {
    wdtClassroomSettings(where: $where) {
      ...BaseWdtClassroomSettings
    }
  }
  ${WDT_CLASSROOM_SETTINGS_FRAGMENT}
`;

export default GET_GSS_CLASSROOM_SETTINGS;
